import { render } from "./AlphaGoat04.vue?vue&type=template&id=3301ac58&scoped=true"
const script = {}

import "./AlphaGoat04.vue?vue&type=style&index=0&id=3301ac58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3301ac58"]])

export default __exports__